import { Route, Routes } from 'react-router';
import AuthenticatedRoute from 'app/containers/App/components/AuthenticatedRoute';
import { GovernanceTagsExplorer } from '../index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GovernanceTagsRouter = (childProps: any) => (
  <Routes>
    <Route
      index
      element={
        <AuthenticatedRoute
          component={GovernanceTagsExplorer}
          props={childProps}
          remountKey={() => 'tag-governance'}
        />
      }
    />
  </Routes>
);

export default GovernanceTagsRouter;
